import { render, staticRenderFns } from "./IPRouteList.vue?vue&type=template&id=356edfe1&"
import script from "./IPRouteList.vue?vue&type=script&lang=js&"
export * from "./IPRouteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports